import * as React from "react";
import { AuthPiece } from "aws-amplify-react";
import { JS, Auth, I18n } from "aws-amplify";
import {
  FormSection,
  FormField,
  SectionHeader,
  SectionBody,
  SectionFooter,
  Button,
  Link,
  Hint,
  Input,
  InputLabel,
  SectionFooterPrimaryContent
} from "aws-amplify-react/dist/Amplify-UI/Amplify-UI-Components-React";
import { auth } from "aws-amplify-react/dist/Amplify-UI/data-test-attributes";

export default class CustomSignIn extends AuthPiece {
  constructor(props) {
    super(props);

    this.checkContact = this.checkContact.bind(this);
    this.signIn = this.signIn.bind(this);

    this._validAuthStates = ["signIn", "signedOut", "signedUp"];
    this.state = {};
  }

  checkContact(user) {
    if (!Auth || typeof Auth.verifiedContact !== "function") {
      throw new Error("No Auth module found, please ensure @aws-amplify/auth is imported");
    }
    Auth.verifiedContact(user).then(data => {
      if (!JS.isEmpty(data.verified)) {
        this.changeState("signedIn", user);
      } else {
        user = Object.assign(user, data);
        this.changeState("verifyContact", user);
      }
    });
  }

  async signIn(event) {
    // avoid submitting the form
    if (event) {
      event.preventDefault();
    }
    let username;
    if (this && this.getUsernameFromInput) {
      username = `${this.getUsernameFromInput()}`.replace(/\s/g, "");
      username = username.trim();
    }
    const { password } = this.inputs;

    if (!Auth || typeof Auth.signIn !== "function") {
      throw new Error("No Auth module found, please ensure @aws-amplify/auth is imported");
    }
    this.setState({ loading: true });
    try {
      const user = await Auth.signIn(username, password);
      if (user.challengeName === "SMS_MFA" || user.challengeName === "SOFTWARE_TOKEN_MFA") {
        this.changeState("confirmSignIn", user);
      } else if (user.challengeName === "NEW_PASSWORD_REQUIRED") {
        this.changeState("requireNewPassword", user);
      } else if (user.challengeName === "MFA_SETUP") {
        this.changeState("TOTPSetup", user);
      } else {
        this.checkContact(user);
      }
    } catch (err) {
      if (err.code === "UserNotConfirmedException") {
        this.changeState("confirmSignUp", { username });
      } else if (err.code === "PasswordResetRequiredException") {
        this.changeState("forgotPassword", { username });
      } else {
        this.error(err);
      }
    } finally {
      this.setState({ loading: false });
    }
  }

  showComponent(theme) {
    const hideForgotPassword = false;
    return (
      <FormSection theme={theme} data-test={auth.signIn.section}>
        <SectionHeader>
          <div>
            <div className="navbar-logo-sign">
              <span className="logo-sign d-none d-xs-block" />
              <span className="logo-mobile-sign d-block d-xs-none" />
            </div>
          </div>
        </SectionHeader>

        <form onSubmit={this.signIn}>
          <SectionBody theme={theme}>
            {this.renderUsernameField(theme)}
            <FormField theme={theme}>
              <InputLabel theme={theme}>{I18n.get("Password")} *</InputLabel>
              <Input
                placeholder={I18n.get("Enter your password")}
                theme={theme}
                key="password"
                type="password"
                name="password"
                onChange={this.handleInputChange}
                data-test={auth.signIn.passwordInput}
              />

              {!hideForgotPassword && (
                <Hint theme={theme}>
                  {I18n.get("Forget your password? ")}
                  <Link theme={theme} onClick={() => this.changeState("forgotPassword")} data-test={auth.signIn.forgotPasswordLink}>
                    {I18n.get("Reset password")}
                  </Link>
                </Hint>
              )}
            </FormField>
          </SectionBody>

          <SectionFooter theme={theme} data-test={auth.signIn.footerSection}>
            <SectionFooterPrimaryContent theme={theme}>
              <Button theme={theme} type="submit" disabled={this.state.loading} data-test={auth.signIn.signInButton}>
                {I18n.get("Sign In")}
              </Button>
            </SectionFooterPrimaryContent>
          </SectionFooter>
        </form>
      </FormSection>
    );
  }
}
